import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BaseComponent } from './base.component';
import { Manager } from '../models/Manager';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'secured-base',
  template: ''
})
export class SecuredBaseComponent extends BaseComponent {

  manager!: Manager;
  
  constructor(public override snackBar: MatSnackBar, public router: Router, public managerService: ManagerService) {
    super(snackBar);
  }

  ngOnInit() {
    if (!this.managerService.getToken())
      this.router.navigate(['/login']);

    this.manager = this.managerService.getLoggedUser();
  }
}